module.exports = __webpack_public_path__ + "img/fa4c643243710bce9a763fba61abbca6.a16ed7de.png";